module.exports = __webpack_public_path__ + "static/img/bcg_unit6.e9593a6d.png";